import ReactDOMServer from "react-dom/server";
import LogoHeader from "../../../../../components/common/LogoHeader";

export function PrintPayrollListPage(objects, payrollData) {
  console.log("PAYROLLL DATA", payrollData);
  console.log("objects", objects);
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";
  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;
  const formHeaderHTML = ReactDOMServer.renderToString(
    <div className="d-flex justify-content-center flex-column align-items-center flex-md-row p-2">
      <LogoHeader
        logoSrc={"/BIR.png"}
        rightLogoSrc={"/Bagong-Pilipinas-Logo.png"}
        altText="Print Logo"
        mainLabel="Republic Of the Philippines"
        subLabel="BUREAU OF IMMIGRATION"
        description="Patriotism * Integrity * Professionalism"
      />
      {/* <img
        src={"/Bagong-Pilipinas-Logo.png"}
        className="img-fluid"
        style={{ maxWidth: "130px", maxHeight: "110px" }}
      /> */}
    </div>
  );

  const styles = Array.from(
    document.querySelectorAll("link[rel='stylesheet'], style")
  )
    .map((styleElement) => styleElement.outerHTML)
    .join("\n");

  const tableRows = objects
    .map((obj) => {
      const matchingPayroll = payrollData.find(
        (item) => item?.employee?.id === obj.employee?.id
      );

      const netAmount = matchingPayroll?.netAmount ?? "N/A";
      const fullName = `${obj.employee?.surname} ${obj.employee?.Firstname} ${obj.employee?.Middlename}`;

      return `
      <tr class="tr">
        <td>${fullName}</td>
        <td>${obj.employee?.accountNumber}</td>
        <td>${netAmount}</td>
      </tr>
    `;
    })
    .join("");

  const printContentHTML = `
        <div style="text-align: center;">
        <p style="color: green;">PAYROLL REGISTER</p>
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0;" class="table">
            <thead class="thead">
            <tr>
                <th>Employee</th>
                <th>Account Number</th>
                <th>Amount</th>
            </tr>
            </thead>
            <tbody class="tbody">
            ${tableRows}
            </tbody>
        </table>
        <br></br>
        <p>TOTAL NUMBER OF RECORDS: <b>${objects.length}</b></p>
        </div>
    `;

  iframeDoc.open();
  iframeDoc.write(`
        <html>
        <head>
        <style>
            body {
            font-family: Arial, sans-serif;
            }
            .table {
            width: 100%;
            border-collapse: collapse;
            margin: 20px 0;
            }
            .thead > tr > th, .tr > td {
            border: 1px solid #000;
            padding: 8px;
            text-align: left;
            }
            .thead > th {
            background-color: #f4f4f4;
            border: 1px solid #000;
            padding: 8px;
            }
            .print-content-container {
            text-align: center;
            }
            @media print {
            .print-content-container {
                margin: .3in !important;
                padding: 0;
            }
            @page {
                size: landscape;
                margin: .3in !important;
            }
            }
        </style>
        ${styles}
        </head>
        <body>
        <div class="print-content-container">
            ${formHeaderHTML}
            ${printContentHTML}
        </div>
        </body>
        </html>
    `);
  iframeDoc.close();

  iframe.contentWindow.focus();
  iframe.contentWindow.print();

  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 1000);
}
